import { useState } from 'react';
import { X } from 'lucide-react';
import ProductPricing from './ProductPricing';
import ProductBenefits from './ProductBenefits';
import ProductAvailability from './ProductAvailability';

export default function ProductDetailModal({ product, onClose, onSave }) {
  const [activeTab, setActiveTab] = useState('pricing');

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">{product.name}</h2>
            <p className="text-sm text-gray-500 mt-1">{product.description}</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Tabs */}
        <div className="border-b border-gray-200">
          <div className="flex px-6">
            <button
              onClick={() => setActiveTab('pricing')}
              className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                activeTab === 'pricing'
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              Pricing
            </button>
            <button
              onClick={() => setActiveTab('benefits')}
              className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                activeTab === 'benefits'
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              Benefits
            </button>
            <button
              onClick={() => setActiveTab('availability')}
              className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                activeTab === 'availability'
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              Availability
            </button>
          </div>
        </div>

        {/* Tab Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {activeTab === 'pricing' && (
            <ProductPricing product={product} onSave={onSave} />
          )}
          {activeTab === 'benefits' && (
            <ProductBenefits product={product} onSave={onSave} />
          )}
          {activeTab === 'availability' && (
            <ProductAvailability product={product} onSave={onSave} />
          )}
        </div>
      </div>
    </div>
  );
}